define([], function () {
    "use strict";
    var validUrl = "/authui/preValidVerifycode";
    function changeToSuccess(failResultId, verifyCodeId) {
        $("#" + failResultId).hide();
        $("#" + verifyCodeId).removeClass("iam-input-error");
    }

    function changeToFail(failResultId, verifyCodeId) {
        $("#" + failResultId).show();
        $("#" + verifyCodeId).addClass("iam-input-error");
    }
    function clear(failResultId, verifyCodeId) {
        $("#" + failResultId).hide();
        $("#" + verifyCodeId).removeClass("iam-input-error");
    }

    function validateVerifyCode(failResultId, verifyCodeId, verifycode) {
        // 过滤掉ios中文输入法下可能出现的特殊空格字符
        verifycode = verifycode.replace(/\u2006/g, "");
        if (verifycode === "" || verifycode === undefined) {
            clear(failResultId, verifyCodeId);
            return false;
        }
        if (verifycode.length < 4) {
            changeToFail(failResultId, verifyCodeId);
            return false;
        } else {
            return true;
        }
    }

    function substrVerifyCode(verifycode) {
        if (verifycode === "" && verifycode === undefined) {
            return "";
        }
        if (verifycode.length > 4) {
            return verifycode.substring(0, 4);
        }
        else {
            return verifycode;
        }
    }

    function checkVerifyCode(failResultId, verifyCodeId, verifycode, index, callback, iamHttpService, i18n) {
        iamHttpService.post({
            url: validUrl,
            params: {
                verifycode: verifycode,
                index: index
            }
        }).then(function (data) {
            if (data === "success") {
                changeToSuccess(failResultId, verifyCodeId);
            } else {
                changeToFail(failResultId, verifyCodeId);
                callback();
            }
        }, function () {
            if (i18n) {
                // 接口异常 提示用户刷新页面
                angular.element("#serverError").removeClass("ng-hide");
                angular.element("#serverError").css("display", "block");
                angular.element("#serverError>span:first").text(i18n("systemException"));

                setTimeout(function () {
                    angular.element("#serverError").addClass("ng-hide");
                    angular.element("#serverError").css("display", "none");
                    angular.element("#serverError>span:first").text("");
                }, 10000);
            }
        }
        );
    }

    function preValidVerifyCodeNew(failResultId, verifyCodeId, verifycode, index, callback, iamHttpService, i18n) {
        if (validateVerifyCode(failResultId, verifyCodeId, verifycode) === false) {
            return;
        }
        checkVerifyCode(failResultId, verifyCodeId, substrVerifyCode(verifycode), index, callback, iamHttpService, i18n);
    }

    return {
        preValidVerifyCodeNew: preValidVerifyCodeNew
    };
});


// WEBPACK FOOTER //
// ./public/base/utils/preVerifycodeUtilNew.js